import { useSelector } from 'react-redux'
import { RootState } from 'store'

import { Box } from '@mui/material'
import Title from 'components/title/Title'
import BenchmarksTable from 'containers/tables/benchmarks/BenchmarksTable'

export default function BenchmarksListPage() {
  const userId = useSelector((state: RootState) => state.account.userId)
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        p={5} // Padding 40px equals p={5} in MUI (1 = 8px)
      >
        <Title sx={{ pb: 3 }}>All benchmark reports</Title>
        <BenchmarksTable userId={userId} />
      </Box>
    </>
  )
}
